import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "icon", "level"];
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { StyledDropdownHeading } from './DropdownHeading.styles';

/**
 * A header for the `Dropdown` component.
 *
 * @extends Flex
 * @related [`DropdownButton`, `DropdownIcon`, `DropdownPopper`]
 * @since 8.60.0
 */
export var DropdownHeading = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var children = _ref.children,
    icon = _ref.icon,
    level = _ref.level,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledDropdownHeading, _extends({
    as: "h" + level,
    ref: forwardedRef,
    display: "flex",
    alignItems: "center"
  }, rest), icon, children);
});
DropdownHeading.displayName = 'DropdownHeading';
DropdownHeading.propTypes = {
  /**
   * An optional `Icon` node.
   */
  icon: PropTypes.node,
  /**
   * A string or number representing the heading level
   */
  level: PropTypes.oneOf(['1', '2', '3', '4', '5', '6', 1, 2, 3, 4, 5, 6])
};
DropdownHeading.defaultProps = {
  level: 6
};